import http from '../utils/http';
import i18n from '@/main';

const baseRoute = '/papel-pessoa';

export default {
  buscarPapelPorLocalidade(localidade) {
    return http.get({
      url: baseRoute + `?language=${localidade}`,
      lockMessage: i18n.t('mensagens.sistema.buscandoListaDePapeisDePessoa')
      });
  }
};
